import React, { useState, useEffect } from 'react';
import { Dialog, Toolbar, IconButton, Typography, Button, Icon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useStyles from './ReassignModal.styles';
import { get, set, size } from 'global/lib/lodash';
import Alert from '@mui/material/Alert';
import { useScreen, Loader } from 'global/styles';
import sendData from 'redux/actions/sendData';
import Form from 'global/components/form';
import { Column, Row } from '../../../global/components/row';
import { Text } from '../../../global/components/text';
import { TradeSelect } from '../../../global/components/trade-select';
import { CheckpointScore } from '../../report/ChecklistScores';
import { cleanCopy } from '../../../global/utils';
import { AUTOTAG } from '../../report/AssessmentScore';
import { SETTINGS, taskOptions } from '../../admin/account-settings';
import { getAccountSetting } from 'redux/actions/userLogin';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({});
  const [items, setItems] = useState({});
  const [open, setOpen] = useState({});

  const { isMobileXS } = useScreen();

  const classes = useStyles();

  const handleClose = (opts) => {
    props.onClose(opts);
  };

  const formSubmit = async () => {
    try {
      if (loading) {
        return;
      }

      setLoading(true);
      if (props.onFormSubmit) {
        await props.onFormSubmit(formState, items);
      } else {
        await Promise.all(
          props.tasks.map(async (task) => {
            const data = {
              data: {
                id: task.id,
                type: 'tasks',
                attributes: {
                  due_date: get(formState, 'dueDate'),
                  meta: get(formState, 'meta', {}),
                },
                relationships: {
                  assignees: {
                    data: get(formState, 'assignedTo', []).map((a) => ({ type: 'users', role: 'assignee', id: a.id })),
                  },
                },
              },
            };
            await sendData({
              url: `/tasks/${task.id}`,
              method: 'patch',
              data,
            });
          })
        );
      }

      setLoading(false);
      handleClose(true);
    } catch (err) {
      setError(`Error: ${err.message}`);
      setLoading(false);
    }
  };

  const defaults = {
    contentTitle: 'Assignee',
    contentSub: 'Who would you like to assign these tasks to?',
    tradeTitle: 'Trades',
    tradeSub: 'Which trades are responsible for these tasks?',
    ...props,
  };

  useEffect(() => {
    if (!!props.open) {
      const checklist = {
        // [id]: {
        //   loaded: false,
        //   checklist: {},
        //   checkpoints: [],
        // }
      };
      const selectedItems = cleanCopy(props.selectedItems);
      Object.keys({ ...selectedItems }).map((k) => {
        const item = get(selectedItems, k);
        if (item && item.itemType === 'checkpoint') {
          set(checklist, [item.checklistId, 'checklist'], item.checklist);
          if (item.subscores) {
            item.subscores.map((ss) => {
              if (get(ss, 'notes') !== AUTOTAG && (!!get(ss, 'notes') || size(get(ss, 'images', [])) > 0)) {
                const exists = !!get(checklist, [item.checklistId, 'checkpoints'], []).find(f => f.id == ss.id);
                if (exists) { return }
                set(checklist, [item.checklistId, 'checkpoints'], [...get(checklist, [item.checklistId, 'checkpoints'], []), ss]);
              }
            });
            delete item.subscores;
          } else {
            set(checklist, [item.checklistId, 'checkpoints'], [...get(checklist, [item.checklistId, 'checkpoints'], []), item]);
          }
        }
      });

      setItems(checklist);
    } else {
      setItems({});
    }
  }, [props.open]);

  const setLoadAndUpdateChildren = (check, sel) => {
    const { checklist } = check;
    checklist.tradeTypes = sel;

    setItems((s) => {
      const ch = get(s, checklist.id, {});
      return {
        ...s,
        [checklist.id]: {
          loaded: true,
          checklist,
          checkpoints: get(ch, 'checkpoints', []).map((c) => {
            c.tradeTypes = size(c.tradeTypes) ? c.tradeTypes : sel;
            return c;
          }),
        },
      };
    });
  };

  const updateChecks = (check, sel, cp) => {
    const { checklist, loaded } = check;
    if (!cp) {
      checklist.tradeTypes = sel;
    }
    setItems((s) => {
      const ch = get(s, checklist.id, {});
      return {
        ...s,
        [checklist.id]: {
          loaded: get(ch, 'loaded', false),
          checklist,
          checkpoints: get(ch, 'checkpoints', []).map((c) => {
            const setTrades = () => {
              c.tradeTypes = size(c.tradeTypes) && !loaded ? c.tradeTypes : sel;
            };

            if (cp) {
              if (c.id == cp.id) {
                setTrades();
              }
            } else {
              setTrades();
            }

            return c;
          }),
        },
      };
    });
  };

  const toggleOpen = (check, _i) => {
    const key = `${check.checklist.id}_${_i}`;
    setOpen((o) => ({ ...o, [key]: !o[key] }));
  };

  const renderChecklist = (check, i) => {
    const { checklist, checkpoints } = check;

    if (!checklist) {
      return null;
    }

    const fixMargins = { marginLeft: 5, pointerEvents: 'none' };

    const title = (style = {}) => {
      return (
        <Row style={style}>
          <Text bold type="title_medium">{`${get(checklist, 'name', '')} (${size(checkpoints)})`}</Text>
        </Row>
      );
    };

    const CONT = isMobileXS ? Column : Row;

    const renderCP = (cp, _i) => {
      const isOpen = get(open, `${checklist.id}_${_i}`);

      const renderCheckpointScore = (_cp, style) => {
        return <CheckpointScore pssvCheckpoint={_cp} checklist={checklist} showDrop={false} showContent={!!style.cursor && !!isOpen} showDisplayScore={false} />;
      };

      const cpTitle = (style = { cursor: 'pointer', marginLeft: -20, maxWidth: isMobileXS ? undefined : '50%' }) => {
        return (
          <Row style={style} onClick={() => toggleOpen(check, _i)}>
            {renderCheckpointScore(cp, style)}
            {!!style.cursor && <Icon>{isOpen ? 'arrow_drop_down' : 'arrow_right'}</Icon>}
          </Row>
        );
      };

      return (
        <div style={{ marginBottom: isMobileXS ? 10 : 0 }}>
          <CONT>
            {cpTitle()}
            <div style={{ marginLeft: isMobileXS ? 20 : 'auto' }}>
              <TradeSelect
                type="inlineModal"
                value={cp.tradeTypes}
                compare={checklist.tradeTypes}
                checklist={{ ...checklist, checklistId: checklist.id }}
                onChange={(s) => updateChecks(check, s, cp)}
                modalTitle={cpTitle(fixMargins)}
                highlightOriginals
              />
            </div>
          </CONT>
        </div>
      );
    };

    if (!size(checkpoints)) {
      return null;
    }

    return (
      <div>
        <CONT className={classes.checklistHeader}>
          {title()}
          <div style={{ marginLeft: isMobileXS ? 0 : 'auto' }}>
            <TradeSelect
              checklist={{ ...checklist, checklistId: checklist.id }}
              onChecklistTradesLoaded={(s) => setLoadAndUpdateChildren(check, s)}
              onChange={(s) => updateChecks(check, s)}
              type="inlineModal"
              modalTitle={title({ ...fixMargins, marginLeft: 30, marginTop: 4 })}
            />
          </div>
        </CONT>

        {(checkpoints || []).map(renderCP)}
      </div>
    );
  };

  const showTrades = get(props, 'showTrades', false);
  const showDueDate = get(props, 'showDueDate', true);
  const showTaskDefaults = get(props, 'showTaskDefaults', true);

  return (
    <Dialog className={classes.dialog} fullScreen disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <Toolbar className={classes.toolbar}>
        <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close" size="large">
          <CloseIcon />
        </IconButton>

        <div className={classes.barTitle}>
          <Typography variant="h5" className={classes.title}>
            {props.title}
          </Typography>
        </div>
      </Toolbar>

      <div className={classes.container}>
        {error && (
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {error}
          </Alert>
        )}

        <div>
          <Typography variant="h5">{defaults.contentTitle}</Typography>
          <Typography variant="subtitle1">{defaults.contentSub}</Typography>
        </div>

        <div>
          <Form
            loading={loading}
            showAllScreens={true}
            formStyle={classes.formStyle}
            onSubmit={formSubmit}
            isNoMarginContainer
            onFormState={(vals) => {
              setFormState(vals);
            }}
            screens={[
              {
                title: '',
                titleStyle: classes.titleStyle,
                screenContainerStyle: isMobileXS ? classes.screenContainerMobile : classes.screenContainer,
                screenContainer: {
                  props: {
                    className: classes.screenWidth,
                  },
                },
                inputs: [
                  {
                    id: 'assignedTo',
                    type: 'UserSelect',
                    defaultValue: () => get(props, 'tasks.0.assignees', []),
                    data: () => props.assignees,
                    props: {
                      label: 'Assigned To',
                      ...get(props, 'assignedToProps', {}),
                    },
                  },
                  showDueDate && {
                    id: 'dueDate',
                    type: 'KeyboardDatePicker',
                    props: {
                      label: 'Due Date',
                    },
                  },
                  showTaskDefaults && {
                    id: 'meta',
                    type: 'Checkbox',
                    options: taskOptions(),
                    defaultValue: () => getAccountSetting(SETTINGS.taskDefault),
                    props: {
                      label: 'Requirements',
                    },
                  },
                ].filter((f) => !!f),
              },
            ]}
          />

          {showTrades && (
            <div style={{ marginTop: 8 }}>
              <div>
                <Typography variant="h5">{defaults.tradeTitle}</Typography>
                <Typography variant="subtitle1">{defaults.tradeSub}</Typography>
              </div>

              {Object.keys(items).map((k, i) => renderChecklist(items[k], i))}
            </div>
          )}

          <div className={classes.buttonContainer}>
            {typeof props.buttons === 'function' ? (
              props.buttons({ formState })
            ) : (
              <Button onClick={() => formSubmit()} startIcon={loading ? <Loader size={16} /> : <Icon>person_add</Icon>} className={classes.button} variant="contained" disabled={loading}>
                {props.okButton || 'RE-ASSIGN'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};
